<template>
  <div>
    <slot v-if="isEnabled()" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "vuex";

// Feature flag helper component. Hides child elements if given feature is not enabled
export default defineComponent({
  name: "FeatureGuard",
  props: {
    feature: {
      type: String,
      default: null,
    },
  },
  data: function () {
    return {};
  },
  computed: { ...mapState(["features"]) },
  methods: {
    isEnabled() {
      if (this.features[this.feature] === false) {
        return false;
      }
      return true;
    },
  },
});
</script>
